import CommonStyle from "@/utils/CommonStyle";

/*
addUrl: "",
deleteUrl: "",
editUrl: "",
queryUrl: "",
*/

export default {
    data() {
        return {
            tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
            curPage: 1,
            limit: 10,
            total: 0,
            query: {},
            formInfo: {},
            formInfoRules: {},
            tableData: [],
            tableLate:[], // 未完成课程的学生表格
            multipleSelection: [],
            dialogTitle: 0,
            dialogVisible: false,
            time:60, // 提醒学生的的短信倒计时
        };
    },
    methods: {
      // 获取所有学生列表
        queryData() {
            let that = this;
            that.HttpConnection.get(that.queryUrl, {
                params: that.getQueryParame()
            }).then(function(response) {
                that.tableData = response.rows;
                that.total = response.total;
            }).catch(function(error) {
                that.tableData = null;
                that.total = 0;
                that.$message({
                    type: "error",
                    message: error.msg
                });
            });
        },
        // 获取未完成课程的学生列表
        getList () {
         let that = this;
         that.HttpConnection.get("/teach/user/list/uncompleted", {
            params:  that.getQueryParame()
          }).then(res => {
            if(res.code === 200){
               this.tableLate = res.rows
            }
          }).catch(err => { 
            that.$message({
              type: "error",
              message: error.msg
          });
          })
        },
        getQueryParame() {
            return {
                current: this.curPage,
                size: this.limit,
                ...this.query
            };
        },
        // 查询
        toQuery() {
          if(this.tab == false){
            this.curPage = 1;
            this.queryData();
          }else{
            this.curPage = 1;
            this.getList();
          }
        },
        // 重置
        resetQuery() {
          if(this.tab == false){
            this.curPage = 1;
            this.query.nickName = '';
            this.queryData();
          }else{
            this.curPage = 1;
            this.query.nickName = '';
            this.getList();
          }
        },
        // 提醒学生
        Remind(){
          let that = this;
          if(that.time == 60){
            that.HttpConnection.post("/teach/user/send/uncompleted",that.getQueryParame()).then(res => {
              that.$message({
                type: "success",
                message:"提醒成功"
              });
              clearTimeout(timeout)
              var timeout = setTimeout(() => {
                 that.time--;
                if(that.time >= 1){
                  that.time = 60;
                }
              }, 1000);
           }).catch(err =>{
              that.$message({
                type: "error",
                message: error.msg
              });
            })
          }else{
            that.$message({
              type: "error",
              message:"1分钟只能提醒一次"
            });
          }
        },
        refreshQuery() {
            this.queryData();
        },
        handleSizeChange(val) {
            this.limit = val;
            this.queryData();
        },
        handleCurrentChange(val) {
            this.curPage = val;
            this.queryData();
        },
        handleAdd() {
            this.dialogVisible = true;
            this.dialogTitle = 0;
        },
        handleEdit(index, row) {
            this.formInfo = row;
            this.dialogVisible = true;
            this.dialogTitle = 1;
        },
        handleDelete(index, row) {

        },
        handleDeleteMultiple() {

        },
        delteData(ids) {
            let that = this;
            that.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                that.HttpConnection.post(that.deleteUrl, ids).then(function(response) {
                    that.queryData();
                    that.$message({
                        type: "success",
                        message: "删除成功!"
                    });
                }).catch(function(error) {
                    that.$message({
                        type: "error",
                        message: error.msg
                    });
                });
            }).catch(() => {
                that.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        submitForm(formInfo) {
            let that = this;
            this.$refs[formInfo].validate((valid) => {
                if (valid) {
                    let _apiTemp = "";
                    if (that.dialogTitle === 0) {
                        _apiTemp = that.addUrl;
                    } else if (that.dialogTitle === 1) {
                        _apiTemp = that.editUrl;
                    }
                    that.HttpConnection.post(_apiTemp, that.formInfo).then(function(response) {
                        that.dialogVisible = false;
                        that.$refs[formInfo].resetFields();
                        that.formInfo = {};
                        that.queryData();
                        that.$message({
                            type: "success",
                            message: "操作成功"
                        });
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        resetForm(formInfo) { // 新增 编辑 取消
            this.dialogVisible = false;
            this.$refs[formInfo].resetFields();
            this.formInfo = {};
        }
    }
};
